import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Image from '../Image';
import PlayOverlay from '../PlayOverlay';

import './styles.less';

const VideoImageLink = (props) => {
    return (
        <div className={classNames('p-video-image-link', props.className)}>
            <a href={props.url} target={props.newTab ? '_blank' : '_self'}>
                <Image {...props.image} />
                <PlayOverlay position={props.overlayPosition} url="" />
            </a>
        </div>
    );
};

VideoImageLink.propTypes = {
    newTab: PropTypes.bool,
    url: PropTypes.string.isRequired,
    image: PropTypes.shape(Image.propTypes).isRequired,
    overlayPosition: PlayOverlay.propTypes.position,
    className: PropTypes.string,
    videoContentId: PropTypes.string
};

VideoImageLink.defaultProps = {
    newTab: true,
    overlayPosition: 'center',
    className: '',
    videoContentId: undefined
};

export default VideoImageLink;
